import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import { calendarioReducer } from "./calendario";
import { metronic } from "../../_metronic";
import spinner from "./reducers/spinner.reducer";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  i18n: metronic.i18n.reducer,
  builder: metronic.builder.reducer,
  calendario: calendarioReducer,
  spinner
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
